import { useEffect, useState } from 'react';
import { absenceApi } from '../../../api/absence.js';

/**
 * Absence plans admin — list/create plans (unit days|hours, paid, statutory).
 */
export default function PlansPage() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showCreate, setShowCreate] = useState(false);

  function refresh() {
    setLoading(true);
    absenceApi
      .listPlans()
      .then((r) => setPlans(r?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load plans'))
      .finally(() => setLoading(false));
  }
  useEffect(refresh, []);

  async function createPlan(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    try {
      await absenceApi.createPlan({
        name: fd.get('name'),
        unit: fd.get('unit') || 'days',
        paid: fd.get('paid') === 'on',
        statutory: fd.get('statutory') === 'on',
      });
      e.target.reset();
      setShowCreate(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create plan');
    }
  }

  async function removePlan(id) {
    try {
      await absenceApi.deletePlan(id);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete plan');
    }
  }

  return (
    <section data-testid="absence-plans-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div>
          <h1>Absence Plans</h1>
          <p className="muted">{plans.length} plans</p>
        </div>
        <button className="btn primary" data-testid="absence-plan-create" onClick={() => setShowCreate((s) => !s)}>
          {showCreate ? 'Close' : '+ Plan'}
        </button>
      </header>

      {error && <div className="alert error" data-testid="absence-plans-error">{error}</div>}

      {showCreate && (
        <form onSubmit={createPlan} className="card form-card grid-form">
          <label>Name<input name="name" data-testid="absence-plan-name-input" required /></label>
          <label>Unit
            <select name="unit" defaultValue="days" data-testid="absence-plan-unit-input">
              <option value="days">days</option>
              <option value="hours">hours</option>
            </select>
          </label>
          <label className="check"><input name="paid" type="checkbox" defaultChecked data-testid="absence-plan-paid-input" /> Paid</label>
          <label className="check"><input name="statutory" type="checkbox" data-testid="absence-plan-statutory-input" /> Statutory</label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="absence-plan-submit">Create plan</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="absence-plan-list">
          <thead><tr><th>Name</th><th>Unit</th><th>Paid</th><th>Statutory</th><th>Active</th><th></th></tr></thead>
          <tbody>
            {plans.map((p) => (
              <tr key={p.id} data-testid={`absence-plan-row-${p.id}`}>
                <td>{p.name}</td>
                <td>{p.unit}</td>
                <td>{p.paid ? 'yes' : 'no'}</td>
                <td>{p.statutory ? <span className="badge">statutory</span> : 'no'}</td>
                <td>{p.active ? 'yes' : 'no'}</td>
                <td><button className="btn ghost" data-testid={`absence-plan-delete-${p.id}`} onClick={() => removePlan(p.id)}>Delete</button></td>
              </tr>
            ))}
            {!loading && plans.length === 0 && <tr><td colSpan={6} className="muted">No plans yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
